export default __webpack_public_path__ + "static/media/img4.604cbb7b.jpg";